import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { CarouselModule } from "ngx-owl-carousel-o";
import { StoreDevtoolsModule } from "@ngrx/store-devtools";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { GalleryPageComponent } from "./components/pages/gallery-page/gallery-page.component";
import { EventsPageComponent } from "./components/pages/events-page/events-page.component";
import { ErrorPageComponent } from "./components/pages/error-page/error-page.component";
import { CaseStudiesThreeColumnsPageComponent } from "./components/pages/case-studies-three-columns-page/case-studies-three-columns-page.component";
import { FooterComponent } from "./components/layouts/footer/footer.component";
import { PreloaderComponent } from "./components/layouts/preloader/preloader.component";
import { HomepageOneComponent } from "./components/pages/homepage-one/homepage-one.component";
import { SolutionsComponent } from "./components/common/solutions/solutions.component";
import { HomeoneServicesComponent } from "./components/pages/homepage-one/homeone-services/homeone-services.component";
import { HomeoneProcessComponent } from "./components/pages/homepage-one/homeone-process/homeone-process.component";
import { HomeoneCaseStudiesComponent } from "./components/pages/homepage-one/homeone-case-studies/homeone-case-studies.component";
import { HomeoneScientistComponent } from "./components/pages/homepage-one/homeone-scientist/homeone-scientist.component";
import { HomeoneTestimonialsComponent } from "./components/pages/homepage-one/homeone-testimonials/homeone-testimonials.component";
import { HomeonePartnerComponent } from "./components/pages/homepage-one/homeone-partner/homeone-partner.component";
import { HomeoneBlogComponent } from "./components/pages/homepage-one/homeone-blog/homeone-blog.component";
import { ProjectStartComponent } from "./components/common/project-start/project-start.component";
import { HomeoneAboutComponent } from "./components/pages/homepage-one/homeone-about/homeone-about.component";
import { HomeoneBannerComponent } from "./components/pages/homepage-one/homeone-banner/homeone-banner.component";
import { HomepageTwoComponent } from "./components/pages/homepage-two/homepage-two.component";
import { HometwoPartnerComponent } from "./components/pages/homepage-two/hometwo-partner/hometwo-partner.component";
import { HometwoTestimonialsComponent } from "./components/pages/homepage-two/hometwo-testimonials/hometwo-testimonials.component";
import { HometwoScientistComponent } from "./components/pages/homepage-two/hometwo-scientist/hometwo-scientist.component";
import { HometwoProcessComponent } from "./components/pages/homepage-two/hometwo-process/hometwo-process.component";
import { HometwoServicesComponent } from "./components/pages/homepage-two/hometwo-services/hometwo-services.component";
import { HometwoFunfactsComponent } from "./components/pages/homepage-two/hometwo-funfacts/hometwo-funfacts.component";
import { HometwoMissionComponent } from "./components/pages/homepage-two/hometwo-mission/hometwo-mission.component";
import { HometwoAboutComponent } from "./components/pages/homepage-two/hometwo-about/hometwo-about.component";
import { HometwoBannerComponent } from "./components/pages/homepage-two/hometwo-banner/hometwo-banner.component";
import { HometwoBoxesComponent } from "./components/pages/homepage-two/hometwo-boxes/hometwo-boxes.component";
import { HomethreeBannerComponent } from "./components/pages/homepage-three/homethree-banner/homethree-banner.component";
import { HomepageThreeComponent } from "./components/pages/homepage-three/homepage-three.component";
import { HomethreePartnerComponent } from "./components/pages/homepage-three/homethree-partner/homethree-partner.component";
import { HomethreeFeaturedServicesComponent } from "./components/pages/homepage-three/homethree-featured-services/homethree-featured-services.component";
import { HomethreeAboutComponent } from "./components/pages/homepage-three/homethree-about/homethree-about.component";
import { HomethreeMissionComponent } from "./components/pages/homepage-three/homethree-mission/homethree-mission.component";
import { HomethreeFunfactsComponent } from "./components/pages/homepage-three/homethree-funfacts/homethree-funfacts.component";
import { HomethreeCoursesComponent } from "./components/pages/homepage-three/homethree-courses/homethree-courses.component";
import { HomethreeExploreLearningComponent } from "./components/pages/homepage-three/homethree-explore-learning/homethree-explore-learning.component";
import { HomethreeBootcampsComponent } from "./components/pages/homepage-three/homethree-bootcamps/homethree-bootcamps.component";
import { HomethreeTestimonialsComponent } from "./components/pages/homepage-three/homethree-testimonials/homethree-testimonials.component";
import { HomethreeBlogComponent } from "./components/pages/homepage-three/homethree-blog/homethree-blog.component";
import { SubscribeComponent } from "./components/common/subscribe/subscribe.component";
import { NavbarComponent } from "./components/layouts/navbar/navbar.component";
import { AboutPageComponent } from "./components/pages/about-page/about-page.component";
import { AboutpageAboutComponent } from "./components/pages/about-page/aboutpage-about/aboutpage-about.component";
import { TeamPageComponent } from "./components/pages/team-page/team-page.component";
import { ServicesPageComponent } from "./components/pages/services-page/services-page.component";
import { ServicesDetailsPageComponent } from "./components/pages/services-details-page/services-details-page.component";
import { ContactPageComponent } from "./components/pages/contact-page/contact-page.component";
import { BlogPageComponent } from "./components/pages/blog-page/blog-page.component";
import { BlogDetailsPageComponent } from "./components/pages/blog-details-page/blog-details-page.component";
import { RelatedServicesComponent } from "./components/pages/services-details-page/related-services/related-services.component";
import { CaseStudiesDetailsPageComponent } from "./components/pages/case-studies-details-page/case-studies-details-page.component";
import { RelatedCaseStudiesComponent } from "./components/pages/case-studies-details-page/related-case-studies/related-case-studies.component";
import { FaqPageComponent } from "./components/pages/faq-page/faq-page.component";
import { SearchResultsPageComponent } from "./components/pages/search-results-page/search-results-page.component";
import { EventsDetailsPageComponent } from "./components/pages/events-details-page/events-details-page.component";
import { EventsSpeakersComponent } from "./components/pages/events-details-page/events-speakers/events-speakers.component";
import { CoursesPageComponent } from "./components/pages/courses-page/courses-page.component";
import { CoursesDetailsPageComponent } from "./components/pages/courses-details-page/courses-details-page.component";
import { RelatedCoursesComponent } from "./components/pages/courses-details-page/related-courses/related-courses.component";

import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { MsalModule, MsalGuard, MsalInterceptor } from "@azure/msal-angular"; // MsalGuard added to imports
import { PublicClientApplication, InteractionType } from "@azure/msal-browser"; // InteractionType added to imports
import { environment } from "@environments/environment";
// import { HttpClientInMemoryWebApiModule } from 'angular-in-memory-web-api';// State
import { StoreModule, MetaReducer, ActionReducer } from "@ngrx/store";
import { EffectsModule } from "@ngrx/effects";
import { UserModule } from "./store/user/user.module";
import { localStorageSync } from "ngrx-store-localstorage";
import * as fromUser from "./store/user/reducer";
import { routerReducer } from "@ngrx/router-store";
// Highlight JS
import { HIGHLIGHT_OPTIONS } from 'ngx-highlightjs';
import { TitleService } from './services/title.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DataIngestionRequestModule } from './components/pages/data-ingestion-request/data-ingestion-request.module';
import { WizardsModule } from './components/pages/wizard/wizard.module';
import { HomepageFourModule } from './components/pages/homepage-four/homepage-four.module';
import { SharedModule } from './components/common/shared.module';
import { SnowflakeModule } from './store/snowflake/snowflake.module';
import { AddSuccessStoryPageComponent } from './components/pages/add-success-story-page/add-success-story-page.component';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { DatePipe } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatGridListModule } from '@angular/material/grid-list';
import { SuccessStoryDetailsPageComponent } from './components/pages/success-story-details-page/success-story-details-page.component';
import { ThoughtworksDemosComponent } from './components/pages/thoughtworks-demos/thoughtworks-demos.component';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { NgxEditorModule } from "ngx-editor";
import { UploadComponent } from './components/common/upload/upload.component';
import { ThoughtworksDemoService } from './services/thoughtworks-demos.service';
import { InsightsModule } from './app-insights.module';
import { SuccessStoriesPageComponent } from './components/pages/success-stories-page/success-stories-page.component';
import { SuccessStoriesModule } from "./store/stories/successStory.module";
import { KeywordsModule } from "./store/insights/insights.module";

const isIE =
    window.navigator.userAgent.indexOf("MSIE ") > -1 ||
    window.navigator.userAgent.indexOf("Trident/") > -1;

export function localStorageSyncReducer(
    reducer: ActionReducer<any>,
): ActionReducer<any> {
    return localStorageSync({
        keys: [
            fromUser.userStateFeatureKey,
            // fromSnowflake.snowflakeStateFeatureKey,
            // fromTicket.ticketStateFeatureKey
        ],
        rehydrate: true,
    })(reducer);
}

const metaReducers: Array<MetaReducer<any, any>> = [localStorageSyncReducer];

@NgModule({
  declarations: [
    AppComponent,
    GalleryPageComponent,
    EventsPageComponent,
    ErrorPageComponent,
    CaseStudiesThreeColumnsPageComponent,
    FooterComponent,
    PreloaderComponent,
    HomepageOneComponent,
    SolutionsComponent,
    HomeoneServicesComponent,
    HomeoneProcessComponent,
    HomeoneCaseStudiesComponent,
    HomeoneScientistComponent,
    HomeoneTestimonialsComponent,
    HomeonePartnerComponent,
    HomeoneBlogComponent,
    ProjectStartComponent,
    HomeoneAboutComponent,
    HomeoneBannerComponent,
    HomepageTwoComponent,
    HometwoPartnerComponent,
    HometwoTestimonialsComponent,
    HometwoScientistComponent,
    HometwoProcessComponent,
    HometwoServicesComponent,
    HometwoFunfactsComponent,
    HometwoMissionComponent,
    HometwoAboutComponent,
    HometwoBannerComponent,
    HometwoBoxesComponent,
    HomethreeBannerComponent,
    HomepageThreeComponent,
    HomethreePartnerComponent,
    HomethreeFeaturedServicesComponent,
    HomethreeAboutComponent,
    HomethreeMissionComponent,
    HomethreeFunfactsComponent,
    HomethreeCoursesComponent,
    HomethreeExploreLearningComponent,
    HomethreeBootcampsComponent,
    HomethreeTestimonialsComponent,
    HomethreeBlogComponent,
    SubscribeComponent,
    NavbarComponent,
    AboutPageComponent,
    AboutpageAboutComponent,
    TeamPageComponent,
    ServicesPageComponent,
    ServicesDetailsPageComponent,
    ContactPageComponent,
    BlogPageComponent,
    BlogDetailsPageComponent,
    RelatedServicesComponent,
    CaseStudiesDetailsPageComponent,
    RelatedCaseStudiesComponent,
    FaqPageComponent,
    SearchResultsPageComponent,
    EventsDetailsPageComponent,
    EventsSpeakersComponent,
    CoursesPageComponent,
    CoursesDetailsPageComponent,
    RelatedCoursesComponent,
    SuccessStoriesPageComponent,
    AddSuccessStoryPageComponent,
    SuccessStoryDetailsPageComponent,
    ThoughtworksDemosComponent
  ],
  imports: [
    BrowserModule,
    CarouselModule,
    AppRoutingModule,
    HttpClientModule,
    MsalModule.forRoot(new PublicClientApplication({
      auth: {
        clientId: environment.clientId,
        authority: environment.authority,
        redirectUri: environment.redirectUrl,
      },
      cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: true, // Set to true for Internet Explorer 11
      },
    }), {
      interactionType: InteractionType.Redirect, // MSAL Guard Configuration
      authRequest: {
        scopes: ['user.read']
      }
    }, {
      interactionType: InteractionType.Redirect, // MSAL Interceptor Configuration
      protectedResourceMap: new Map([
        [environment.udfApiUrl, [environment.udfApiScopes]],
        // [environment.keplerUrl, [environment.keplerApiScope]]
      ])
    }),
    StoreModule.forRoot(
      { router: routerReducer },
      { metaReducers }
    ),
    EffectsModule.forRoot([]),
    //environment.production ? []:
    // for debug
    // StoreDevtoolsModule.instrument({
    //   maxAge:25,
    //   logOnly: environment.production,
    //   // autoPause: true
    // }),
    BrowserAnimationsModule,
    HomepageFourModule,
    DataIngestionRequestModule,
    SharedModule,
    WizardsModule,
    UserModule,
    SnowflakeModule,
    SuccessStoriesModule,
    KeywordsModule,
    ReactiveFormsModule,
    FormsModule,
    MatCardModule,
    NgxEditorModule,
    MatButtonModule,
    MatGridListModule,
    MatInputModule,
    MatIconModule,
    MatTooltipModule,
    UploadComponent,
    InsightsModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true
    },
    MsalGuard,
    {
      provide: HIGHLIGHT_OPTIONS,
      useValue: {
        coreLibraryLoader: () => import('highlight.js/lib/core'),
        languages: {
          xml: () => import('highlight.js/lib/languages/xml'),
          typescript: () => import('highlight.js/lib/languages/typescript'),
          scss: () => import('highlight.js/lib/languages/scss'),
          json: () => import('highlight.js/lib/languages/json')
        },
      },
    },
    TitleService,
    ThoughtworksDemoService,
    DatePipe,
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        hideRequiredMark: false,
        floatLabel: "auto",
        subscriptSizing: 'fixed'
      }
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
